import { render, staticRenderFns } from "./ABTest.vue?vue&type=template&id=2e4b2060&lang=pug&"
import script from "./ABTest.vue?vue&type=script&lang=ts&"
export * from "./ABTest.vue?vue&type=script&lang=ts&"
import style0 from "./ABTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports